<template>
  <li class="ratebook-remaining" :class="{'over': remaining < 0}">
    <span class="label"></span>
    <span class="value">
      Remaining Whole Life Cost Budget:
      <VDropdown v-if="tooltip">
        <span class="tooltip-info" style="margin-right:10px;">?</span>
        <template #popper>
          <p>{{ tooltip }}</p>
        </template>
      </VDropdown>
      £{{ remaining.toFixed(2) }}
    </span>
  </li>
</template>

<script>
export default {
  name: 'remaining-wlc-row',
  props: {
    /** The remaining whole-life cost budget amount (£). Negative values trigger the "over" highlight. */
    remaining: {
      type: Number,
      required: true,
    },
    /** Optional tooltip text. Shown as a "?" hotspot when provided. */
    tooltip: {
      type: String,
      default: null,
    },
  },
}
</script>
